export const ROLES = {
  ADMINISTRATOR: 'Administrator',
  IT_SECURITY_ADMIN: 'IT/Security Admin',
  MANAGER: 'Manager',
  EMPLOYEE: 'Employee',
};

export const PERMISSIONS = {
  // Dashboard
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_FULL_DASHBOARD: 'view_full_dashboard',

  // Learners
  VIEW_LEARNERS: 'view_learners',
  VIEW_OWN_TEAM: 'view_own_team',
  MANAGE_LEARNERS: 'manage_learners',

  // Campaigns
  VIEW_CAMPAIGNS: 'view_campaigns',
  LAUNCH_CAMPAIGNS: 'launch_campaigns',
  MANAGE_CAMPAIGNS: 'manage_campaigns',

  // Phishing
  VIEW_PHISHING: 'view_phishing',
  VIEW_TEAM_PHISHING: 'view_team_phishing',
  LAUNCH_PHISHING: 'launch_phishing',
  REPORT_PHISHING: 'report_phishing',

  // Library
  VIEW_LIBRARY: 'view_library',
  MANAGE_LIBRARY: 'manage_library',

  // Reports
  VIEW_OWN_REPORTS: 'view_own_reports',
  VIEW_TEAM_REPORTS: 'view_team_reports',
  VIEW_FULL_REPORTS: 'view_full_reports',

  // Compliance
  VIEW_COMPLIANCE: 'view_compliance',
  MANAGE_COMPLIANCE: 'manage_compliance',

  // Notifications
  VIEW_NOTIFICATIONS: 'view_notifications',
  MANAGE_NOTIFICATIONS: 'manage_notifications',
  SEND_TEAM_REMINDERS: 'send_team_reminders',

  // Remediation
  VIEW_REMEDIATION: 'view_remediation',
  MANAGE_REMEDIATION: 'manage_remediation',

  // Settings
  VIEW_SETTINGS: 'view_settings',
  MANAGE_SETTINGS: 'manage_settings',

  // Training
  VIEW_OWN_TRAINING: 'view_own_training',
  COMPLETE_TRAINING: 'complete_training',
  ASSIGN_TRAINING: 'assign_training',
  SEND_REMINDERS: 'send_reminders',

  // Employees
  VIEW_EMPLOYEES: 'view_employees',
  MANAGE_EMPLOYEES: 'manage_employees',
};

export const ROLE_PERMISSIONS = {
  [ROLES.ADMINISTRATOR]: Object.values(PERMISSIONS),

  [ROLES.IT_SECURITY_ADMIN]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_FULL_DASHBOARD,
    PERMISSIONS.VIEW_LEARNERS,
    PERMISSIONS.MANAGE_LEARNERS,
    PERMISSIONS.VIEW_EMPLOYEES,
    PERMISSIONS.MANAGE_EMPLOYEES,
    PERMISSIONS.VIEW_CAMPAIGNS,
    PERMISSIONS.LAUNCH_CAMPAIGNS,
    PERMISSIONS.MANAGE_CAMPAIGNS,
    PERMISSIONS.VIEW_PHISHING,
    PERMISSIONS.LAUNCH_PHISHING,
    PERMISSIONS.VIEW_LIBRARY,
    PERMISSIONS.MANAGE_LIBRARY,
    PERMISSIONS.VIEW_FULL_REPORTS,
    PERMISSIONS.VIEW_TEAM_REPORTS,
    PERMISSIONS.VIEW_OWN_REPORTS,
    PERMISSIONS.VIEW_COMPLIANCE,
    PERMISSIONS.MANAGE_COMPLIANCE,
    PERMISSIONS.VIEW_NOTIFICATIONS,
    PERMISSIONS.MANAGE_NOTIFICATIONS,
    PERMISSIONS.SEND_REMINDERS,
    PERMISSIONS.VIEW_REMEDIATION,
    PERMISSIONS.MANAGE_REMEDIATION,
    PERMISSIONS.ASSIGN_TRAINING,
    PERMISSIONS.VIEW_OWN_TRAINING,
    PERMISSIONS.COMPLETE_TRAINING,
    PERMISSIONS.REPORT_PHISHING,
  ],

  [ROLES.MANAGER]: [
    PERMISSIONS.VIEW_DASHBOARD,
    PERMISSIONS.VIEW_OWN_TEAM,
    PERMISSIONS.VIEW_EMPLOYEES,
    PERMISSIONS.VIEW_TEAM_PHISHING,
    PERMISSIONS.VIEW_TEAM_REPORTS,
    PERMISSIONS.VIEW_OWN_REPORTS,
    PERMISSIONS.VIEW_CAMPAIGNS,
    PERMISSIONS.SEND_TEAM_REMINDERS,
    PERMISSIONS.VIEW_OWN_TRAINING,
    PERMISSIONS.COMPLETE_TRAINING,
    PERMISSIONS.REPORT_PHISHING,
    PERMISSIONS.VIEW_COMPLIANCE,
  ],

  [ROLES.EMPLOYEE]: [
    PERMISSIONS.VIEW_OWN_TRAINING,
    PERMISSIONS.COMPLETE_TRAINING,
    PERMISSIONS.VIEW_OWN_REPORTS,
    PERMISSIONS.REPORT_PHISHING,
  ],
};

export const NAV_ACCESS = {
  [ROLES.ADMINISTRATOR]: ['/', '/learners', '/employees', '/campaigns', '/phishing', '/library', '/remediation', '/notifications', '/reports', '/compliance', '/settings'],
  [ROLES.IT_SECURITY_ADMIN]: ['/', '/learners', '/employees', '/campaigns', '/phishing', '/library', '/remediation', '/notifications', '/reports', '/compliance'],
  [ROLES.MANAGER]: ['/', '/employees', '/campaigns', '/reports'],
  [ROLES.EMPLOYEE]: ['/employee/dashboard', '/employee/my-history', '/employee/settings'],
};